import {
    lazyPersonaControlStore,
    lazyInitializeLivePersonaCardForBirthdayEvent,
} from '../lazyFunctions';
import { isoTimestamp } from 'owa-datetime';

export default async function addBirthdayEventMenuAction() {
    let personaControlStore = lazyPersonaControlStore.tryImportForRender();

    // This code exists to ensure that the live persona card is initialized
    if (!personaControlStore || !personaControlStore.isLivePersonaCardInitialized) {
        await lazyInitializeLivePersonaCardForBirthdayEvent.importAndExecute();
        personaControlStore = lazyPersonaControlStore.tryImportForRender();
    }

    if (personaControlStore?.isLivePersonaCardInitialized) {
        const lpc = (window as any).LPC;
        if (!lpc) {
            return;
        }
        lpc.renderCreateContactEditorWithOptions({
            focusPropertyUri: 'PersonaBirthdays',
            initialValues: [{ propertyUri: 'PersonaBirthdays', value: isoTimestamp() }],
        });
    }
}
